import type { App } from "@backend/app";
import { treaty } from "@elysiajs/eden";
import { getActiveMerchantId, getToken, interceptedFetchTyped } from "@/lib/api";

// Eden Treaty client typed directly off the backend's `App = typeof app`.
//
// It reuses the existing request pipeline rather than reinventing it:
// - `fetcher: interceptedFetch` keeps the 401 refresh+retry, the stale-merchant
//   403 recovery, and the E2E token bypass (see lib/api.ts).
// - `headers` supplies the Bearer token + `X-Merchant-Id` per request, exactly
//   like the generated client's `securityWorker`. Omitting the Authorization
//   header when unauthenticated avoids the `Bearer ` (empty) 401 cascade.
//
export const eden = treaty<App>(import.meta.env.VITE_API_BASE_URL || "", {
  // Eden's built-in parseDate is value-based: it converts ANY string matching a
  // date-like regex (ISO datetime, Date.toString(), even bare "2026-06-16" or
  // "16/06/2026") to a Date — so a chat message or note whose text happens to
  // look like a date would be silently corrupted. We disable it and revive
  // dates safely by key in `edenData` (see revive-dates.ts), scoped to the
  // backend's date-named fields only.
  parseDate: false,
  fetcher: interceptedFetchTyped,
  headers: async () => {
    const token = await getToken();
    const merchantId = getActiveMerchantId();
    const h: Record<string, string> = {};
    if (token) h.Authorization = `Bearer ${token}`;
    if (merchantId) h["X-Merchant-Id"] = merchantId;
    return h;
  },
});
